module.exports = "  <div class=\"main-content scrollbarAngular\">\r\n  <div class=\"sub-nav\">\r\n    <h4>All Reports</h4>\r\n    <ul class=\"list-unstyled sub-nav-menu\">   \r\n        <li><a [routerLink]=\"['search']\"><i class=\"fa fa-bus\"></i><section>Sreach</section></a></li>  \r\n    </ul>\r\n  </div>  \r\n    <router-outlet ></router-outlet>\r\n</div>   \r\n\r\n   \r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/AllReports/allReportsMain.component.html
// module id = ./src/app/AllReports/allReportsMain.component.html
// module chunks = main